<div class="row">
    <div class="col-md-3 col-12 mb-3 mb-md-0">
        <div class="page-section mb-0">
            <div class="page-section-header">
                <h2 class="page-section-title">Notes</h2>
                <div class="page-section-actions">
                    <a class="btn btn-sm btn-outline-light" [routerLink]="['/lo', company_uuid, 'call-report', 'new']">+ Add</a>
                </div>
            </div>
            <div class="page-section-body" style="max-height: calc(100vh - 200px); overflow-y: auto;">
                <div class="note-list">
                    <a class="note-list-item" *ngFor="let list of lists"
                        [routerLink]="['/lo', company_uuid, 'call-report', list.uuid]"
                        [class.active]="data.uuid === list.uuid">
                        {{list.title}}
                    </a>
                    <div *ngIf="lists.length == 0" class="text-center text-muted py-4" style="font-size: 12px; font-style: italic;">
                        No notes yet.
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-9 col-12">
        <div class="page-section mb-0">
            <div class="page-section-header">
                <h2 class="page-section-title">{{data.uuid ? 'Edit Note' : 'New Note'}}</h2>
            </div>
            <div class="page-section-form">
                <form (submit)="submit()">
                    <div class="mb-3">
                        <label for="title" class="form-label">Title</label>
                        <input type="text" class="form-control form-control-sm" id="title" name="title" [(ngModel)]="data.title" placeholder="Enter note title..." />
                    </div>
                    <div class="mb-3">
                        <label for="descp" class="form-label">Description</label>
                        <quill-editor id="descp" name="descp" [format]="'html'" [(ngModel)]="data.descp"
                            [styles]="{minHeight: '250px'}"
                            [placeholder]="'Write your note here...'"></quill-editor>
                    </div>
                    <button class="btn btn-primary btn-sm w-100" type="submit" [disabled]="loading">
                        <span *ngIf="!loading">Save Note</span>
                        <span *ngIf="loading">Saving...</span>
                    </button>
                </form>
            </div>
        </div>
    </div>
</div>
